import { getIsLoggedIn } from '@api/selectors/auth';
import { getHost } from '@utils/api-helper/host';
import useFetch from '@hooks/useFetch';
import useMyInfo from '../auth/useMyInfo';

const defaultHost = getHost();

const useGetReferralFeed = () => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const key = isLoggedIn
    ? `${defaultHost}v2/subscriptions/referrals/feed?limit=20&offset=0`
    : null;

  const { data, ...rest } = useFetch(key, { useCamelCase: true });
  return { data: data?.results || [], ...rest };
};

export default useGetReferralFeed;
